export const SYSTEM_MODE = process.env.REACT_APP_MODE || 'PROD'
export const stripePubkeyMY = process.env.REACT_APP_STRIPE_PK_KEY_MY || 'pk_test_fsRjWNEpK52jPPtHKkUvWQHf00rLpW9ylS'
export const stripePubkeySG = process.env.REACT_APP_STRIPE_PK_KEY_SG || "pk_test_j5qbXryuNPm2aHcOxdgqCoIv"
